import { useEffect, useState, useMemo } from "react";
import auth from "../../fire";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../axiosClient";
import SupersetLogoHeader from "../../components/SupersetLogoHeader/SupersetLogoHeader";
import SearchableExerciseList from "../../components/SearchableExerciseList/SearchableExerciseList";
import TextSkeleton from "../../components/SkeletonComponents/TextSkeleton";

const Progression = () => {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();

  const [initialLoading, setIsInitialLoading] = useState(true);
  const [exercises, setExercises] = useState(null);

  const { innerHeight: screenHeight } = window;

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login");
      return;
    }

    getUserExercises();
  }, [user, loading, navigate]);

  const getUserExercises = async () => {
    try {
      const fetchUserExercisesResponse = await axiosClient.get(
        `/api/exercises/allExercisesDoneByUser`
      );
      const userExercises = fetchUserExercisesResponse.data;

      setExercises(userExercises);
      setIsInitialLoading(false);
    } catch (e) {
      console.error("Error fetching user's exercises: " + e);
    }
  };

  const amountOfCardSkeletons = useMemo(() => {
    const listHeight = screenHeight - 248;
    return Math.ceil(listHeight / 46);
  }, [screenHeight]);

  return (
    <>
      <SupersetLogoHeader />
      <div className="p-2 pb-0">
        {initialLoading ? (
          <>
            <TextSkeleton width="300px" height="24px" className="mb-1" />
            <TextSkeleton height="38px" className="mb-4 w-full" />
            <TextSkeleton width="115px" height="24px" className="mb-2" />
            <div className="h-[calc(100vh-248px)] overflow-hidden">
              {Array.from(
                { length: amountOfCardSkeletons },
                (number, index) => (
                  <TextSkeleton
                    key={index}
                    height="42px"
                    className="w-full mb-1"
                  />
                )
              )}
            </div>
          </>
        ) : (
          <>
            <SearchableExerciseList exercises={exercises} />
          </>
        )}
      </div>
    </>
  );
};

export default Progression;
